import { render, staticRenderFns } from "./PrintReceipt.vue?vue&type=template&id=56fe496b&scoped=true"
import script from "./PrintReceipt.vue?vue&type=script&lang=js"
export * from "./PrintReceipt.vue?vue&type=script&lang=js"
import style0 from "./PrintReceipt.vue?vue&type=style&index=0&id=56fe496b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fe496b",
  null
  
)

export default component.exports